import React from "react";
import { Button } from "react-bootstrap";
import { image_thumbnail } from "shared/images/images";
import "./itemcard.scss"
function ItemCardBoard({ items,bidnow}) {
    return (
        <div className="itemcard m-0">
                <div className=" bg-white  h-100 w-100" style={{borderRadius:8}}>
                    <div className="img-container d-flex flex-column align-items-center justify-content-center rounded clickable"  onClick={()=>{bidnow()}}>
                    <img alt="item-image " src={items.itemdisplayurl ? items.itemdisplayurl : image_thumbnail} className="items-image rounded"></img>
                    {/* <img src="https://imageuat.ctbids.com/seller/2025-06-27T1e6669/1051093_KmuOJ5.jpeg" height="98%" width="98%" style={{objectFit:"scale-up"}}/> */}
                    </div>
                    <div className="p-2">
                        <div className="py-2 para">
                            <text className='itemcard-head '>{items.title}</text>
                            {/* <text className='text-bold '>{JSON.stringify(Object.keys(items).join(" "))}</text> */}
                        </div>
                         <div className="">
                            <Button 
                            className=' w-100 btn-grey-light border-0 rounded text-bold'
                            onClick={()=>{bidnow()}}
                            > {items.itemtypeid && items.itemtypeid === 1 ? 'Buy Now' : 'Bid Now'}</Button>
                        </div>
                    </div>
                </div>
        </div>

    )

}
export default ItemCardBoard;